import React, { useState } from "react";
import { AxiosResponse, HttpStatusCode } from "axios";

import {
  VirtualNumberResponse,
  getVirtualNumber as getCommonVirtualNumber,
} from "../../services/rentalStockServices";

import useSimplePopup from "../useSimplePopup";

import CommonPopup from "../../components/Popup";
import BottomGroup from "../../components/Button/Group";
import CommonButton from "../../components/Button";

export type UseVirtualNumberProps = {
  getVirtualNumber?: (
    memberId: number
  ) => Promise<AxiosResponse<VirtualNumberResponse>>;
};

export default function useVirtualNumber({
  getVirtualNumber = getCommonVirtualNumber,
}: UseVirtualNumberProps): [(memberId: number) => void, React.ReactNode] {
  const [popup, setPopup] = useState("");
  const [virtualNumber, setVirtualNumber] = useState("");
  const [simplePopupComponent, { open }] = useSimplePopup({});

  const virtualNumberHandler = async (memberId: number) => {
    try {
      const result = await getVirtualNumber(memberId);

      if (result.status === HttpStatusCode.Ok) {
        setVirtualNumber(result.data.virtualNumber);
        setPopup("virtualTel");
      } else {
        if (result.status) {
          open("안심번호를 가져오는데 실패했습니다.");
        }
      }
    } catch (e: any) {
      if (e?.response?.data?.code === 302) {
        open(
          "사용자 정보를 찾을 수 없거나 연락처가 공백인 유저입니다.\n매니저에게 문의해주세요."
        );
      } else {
        open("안심번호를 가져오는데 실패했습니다.");
      }
    }
  };

  return [
    virtualNumberHandler,
    <>
      <CommonPopup
        isOpen={"virtualTel" === popup}
        onClose={() => setPopup("")}
        padding={0}
        unUseHorizonRule
      >
        <div className="min-h-[110px] p-5 text-base font-medium text-center whitespace-pre-line py-10">
          "<span className="text-brand-primary-magenta">{virtualNumber}</span>
          " 의
          <br />
          번호로 전화를 하시겠습니까?
        </div>
        <div className="pb-[50px]"></div>
        <BottomGroup zIndex="high">
          <div className="flex flex-row h-bottom-button">
            <CommonButton
              variant="grey"
              className="w-full rounded-none"
              onClick={() => {
                setPopup("");
              }}
            >
              취소
            </CommonButton>
            <CommonButton
              className="w-full rounded-none"
              variant="primary"
              onClick={() => {
                window.location.href = `tel:${virtualNumber}`;
                setPopup("");
              }}
            >
              확인
            </CommonButton>
          </div>
        </BottomGroup>
      </CommonPopup>
      {simplePopupComponent}
    </>,
  ];
}
